// src/app/services/menu.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Menu } from '@app/share/type/menu';
import { environment } from 'environments/environment';
import { response } from '@app/share/type';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private http: HttpClient = inject(HttpClient);
  private MENU_URL = environment.systemApi + "/system/menu/tree";

  // getAuthorizedMenus() {
  //   return this.http.get<response<Menu[]>>("./assets/test.json");
  // }
  getAuthorizedMenus() {
    return this.http.get<response<Menu[]>>(this.MENU_URL);
  }
}